import Vue from "vue";
import VueX from "vuex";
import bus from "@/ask/eventBus";
import { getCookie, setCookie } from "@/ask/cookiejs";

Vue.use(VueX);

export default new VueX.Store({
  state: {
    "JWT-TOKEN": getCookie("JWT-TOKEN") === "null" ? null : getCookie("JWT-TOKEN"),
    channelNameList: [], // 渠道名称集合
    isGuidance:false,//是否开启新用户指引
    moduleModalVisible: false ,// 弹框显示状态
    GuideShow:getCookie("JWT-TOKEN") ? true : false,
  },
  mutations: {
    SET_CHANNElDATA(state, list) {
      state.channelNameList = list;
      bus.$emit("saveChannelCallback", list);
    },
    IS_Guidance(state, visibility) {
      state.isGuidance = visibility
    },
    IS_MODULE(state, visibility){
      state.moduleModalVisible = visibility
    },
    Guide_Show(state, visibility){
      state.GuideShow = visibility
    }
  },
  action: {},
});



// WEBPACK FOOTER //
// ./src/store/index.js